/* global window */

"use strict";

import _ from 'underscore';

import { Geobox } from "src/mod-2013/js/geobox.js";

var util = {};

_.extend(util, {
  ukGeobox: new Geobox({
    "south": 49.829,
    "north": 58.988,
    "west": -12.304,
    "east": 3.912
  }),

  compareUnsortedList: function (a, b) {
    if (!a && !b) {
      return false;
    }
    if (!a || !b) {
      return true;
    }
    var difference = _.union(_.difference(a, b), _.difference(b, a));
    return difference.length > 0;
  },

  compareLowercase: function (a, b) {
    if (!a && !b) {
      return false;
    }
    if (!a || !b) {
      return true;
    }
    return a.toLowerCase() !== b.toLowerCase();
  },

  compareGeobox: function (a, b) {
    // Compare two geobox objects
    // a = old, b = new
    // return true if they differ, false otherwise.
    if (!a && !b) {
      return false;
    }
    if (!a || !b) {
      return true;
    }
    // If new has the same name but lacks coords don't remove the coords
    if (!!a.name && a.name === b.name && a.hasCoords() && !b.hasCoords()) {
      return false;
    }
    var difference = a.difference(b);
    if (difference === true || difference === false) {
      return difference;
    }
    return difference > 0.05;
  },

  argumentCheckbox: function (value) {
    if (value === true || value === false) {
      return value;
    }
    return !!parseInt(value, 10);
  },

  argumentMulti: function (valueNew, valueOld) {
    var collection = valueOld ? _.clone(valueOld) : [];
    if (!valueNew) {
      return collection;
    }
    var values;
    if (_.isArray(valueNew)) {
      values = valueNew;
    } else {
      values = [];
      _.each(valueNew.split(","), function (value) {
        values.push(value.replace(/^\s+|\s+$/g, ""));
      });
    }
    return _.union(collection, values);
  },

  multiToString: function (multi) {
    return multi.join(", ");
  },

  checkboxToString: function (value) {
    value = util.argumentCheckbox(value);
    return value && "1" || null;
  },

  argumentVisibility: function (value) {
    if (_.contains(["public", "private", "pending", "all"], value)) {
      return value;
    }
    return null;
  },
  compareVisibility: function (a, b) {
    if (a === b) {
      return false;
    }

    var equals = [undefined, null, "public"];
    if (_.contains(equals, a) && _.contains(equals, b)) {
      return false;
    }

    return true;
  },
  searchString: function () {
    var search = window.location.search;
    if (search) {
      search = search.substr(1);
    }

    return search;
  },

});

export {
  util,
};
